"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2678],{

/***/ 42941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ modal_form; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./components/atoms/modal/index.ts + 1 modules
var modal = __webpack_require__(89575);
;// CONCATENATED MODULE: ./components/molecules/modal-form/ModalForm.tsx


const ModalForm = (param)=>/*#__PURE__*/ {
    let { className ="" , isOpen , closeModal , children , title ="Motivo del contacto"  } = param;
    return (0,jsx_runtime/* jsx */.tZ)(modal["default"], {
        isOpen: isOpen,
        closeModal: closeModal,
        className: "md:w-[590px] ".concat(className),
        title: title,
        unmount: true,
        children: children
    });
};
ModalForm.displayName = "ModalContact";

;// CONCATENATED MODULE: ./components/molecules/modal-form/index.ts

/* harmony default export */ var modal_form = (ModalForm);


/***/ })

}]);